import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material";
import { ExcelService, Combo2Service, ComboService } from "../../../../services/index";
import { SalesOrderService } from "../../../../services/salesOrder.service";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { template } from "lodash";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
// import { forEach } from "../../../../../../node_modules_old/@types/lodash";

@Component({
  selector: "counterdcReport",
  templateUrl: "counterdcReport.html",
})
export class counterdcReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  seasonList = [];
  finyearList = [];
  seasonfinList = [];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  IsWait: boolean = false;
  Iselected_party: boolean = false;
  party_view: boolean = false;

  exceldata: any;
  attachment: any;
  curDate = new Date();

  filter = {
    finyear: "",
    fin_id: "",
    est_partyid: 0,
    season: "",
    from_date: "",
    to_date: "",
    newDesignShade: "",
    shade: "",
    groupby: "designColor",
    ref_no: 0
  };
  tot_data = {
    st_f36: 0,
    st_f38: 0,
    st_f40: 0,
    st_f42: 0,
    st_f44: 0,
    st_f46: 0,
    st_h36: 0,
    st_h38: 0,
    st_h40: 0,
    st_h42: 0,
    st_h44: 0,
    st_h46: 0,
    st_tot: 0,
    bal_f36: 0,
    bal_f38: 0,
    bal_f40: 0,
    bal_f42: 0,
    bal_f44: 0,
    bal_f46: 0,
    bal_h36: 0,
    bal_h38: 0,
    bal_h40: 0,
    bal_h42: 0,
    bal_h44: 0,
    bal_h46: 0,
    bal_tot: 0,
    so_f36: 0,
    so_f38: 0,
    so_f40: 0,
    so_f42: 0,
    so_f44: 0,
    so_f46: 0,
    so_h36: 0,
    so_h38: 0,
    so_h40: 0,
    so_h42: 0,
    so_h44: 0,
    so_h46: 0,
    so_tot: 0,
    est_f36: 0,
    est_f38: 0,
    est_f40: 0,
    est_f42: 0,
    est_f44: 0,
    est_f46: 0,
    est_h36: 0,
    est_h38: 0,
    est_h40: 0,
    est_h42: 0,
    est_h44: 0,
    est_h46: 0,
    est_tot: 0
  }
  columns = [];
  excelColumns = [];
  toggleCol = [];
  newDesignList = [];

  pendingOrderStock: any;
  totpartyOrder: any;
  shirtStock = [];
  partyData = [];
  style_name: any;
  variety_name: any;
  tot_stock: any = 0;
  tab_index: boolean = false;
  est_stock: any
  stockOrder: any;
  balance_qty: any;
  totalOrderPend: any;

  constructor(
    private salesOrderServ: SalesOrderService,
    private spin: MatProgressSpinnerModule,
    public toasterService: ToasterService,
    private excelService: ExcelService,
    private combo: Combo2Service,
    public datePipe: DatePipe,
    public comboservice: ComboService

  ) {
    // let from_date =
    //     this.curDate.getFullYear() +
    //     "-" +
    //     this.curDate.getMonth() +
    //     "-" +
    //     this.curDate.getDate(),
    //   to_date =
    //     this.curDate.getFullYear() +
    //     "-" +
    //     (this.curDate.getMonth() + 1) +
    //     "-" +
    //     this.curDate.getDate();

    this.filter.from_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filter.to_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.finyearCombo();
    this.getSeasonList();
    this.getNewDesignList();
    this.getColumns();
    // this.dcAuto();
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

  }

  dcAuto() {


    this.salesOrderServ.GetCountdcAuto({}).then((res: any) => {
      // this.filter.ref_no = res;
      // this.getWoAuto();
    });

  }

  Oncheckqty() {

    for (let i = 0; i < this.shirtStock.length; i++) {
      let temp = this.shirtStock[i]
      if (temp.bf36 < 0 || temp.bf38 < 0 || temp.bf40 < 0 || temp.bf42 < 0 || temp.bf44 < 0 || temp.bf46 < 0 ||
        temp.bh36 < 0 || temp.bh38 < 0 || temp.bh40 < 0 || temp.bh42 < 0 || temp.bh44 < 0 || temp.bh46 < 0) {
        swal('ERROR', ',<h2>Qty Greater Than Stock</h2>', 'error');
        break
      }
      else {
        this.SaveCounterdc()
      }
    }
  }
  SaveCounterdc() {
    // let params = {

    //   shirt_data: JSON.stringify(this.shirtStock),
    //   ord_data: JSON.stringify(this.pendingOrderStock),
    // }


    let params: any = Object.assign({}, this.filter);
    params["shirt_data"] = JSON.stringify(this.shirtStock);
    params["ord_data"] = JSON.stringify(this.pendingOrderStock);
    params["style"] = this.style_name;
    params["variety"] = this.variety_name;

    let that = this;
    swal({
      title: "Are you sure to save this Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {

      that.salesOrderServ
        .SaveCounterdc(params)
        .then(function (res: any) {

          if (res.success) {
            //    that.printdata(res.printData);
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });

            that.resetTotal();
            // let tabObj = {
            //   action: "CloseTab",
            //   params: {},
            // };
            // that.tabUpdateEvent.emit(tabObj);
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
  resetTotal() {
    this.IsWait = false;
    this.shirtStock = [];
    this.pendingOrderStock = [];
    this.Iselected_party = false;
    this.totpartyOrder = [];
    this.tot_data.so_f36 = 0;
    this.tot_data.so_f38 = 0;
    this.tot_data.so_f40 = 0;
    this.tot_data.so_f42 = 0;
    this.tot_data.so_f44 = 0;
    this.tot_data.so_f46 = 0;
    this.tot_data.so_h36 = 0;
    this.tot_data.so_h38 = 0;
    this.tot_data.so_h40 = 0;
    this.tot_data.so_h42 = 0;
    this.tot_data.so_h44 = 0;
    this.tot_data.so_h46 = 0;
    this.tot_data.so_tot = 0;


    this.tot_data.st_f36 = 0;
    this.tot_data.st_f38 = 0;
    this.tot_data.st_f40 = 0;
    this.tot_data.st_f42 = 0;
    this.tot_data.st_f44 = 0;
    this.tot_data.st_f46 = 0;
    this.tot_data.st_h36 = 0;
    this.tot_data.st_h38 = 0;
    this.tot_data.st_h40 = 0;
    this.tot_data.st_h42 = 0;
    this.tot_data.st_h44 = 0;
    this.tot_data.st_h46 = 0;
    this.tot_data.st_tot = 0;



    this.tot_data.bal_f36 = 0;
    this.tot_data.bal_f38 = 0;
    this.tot_data.bal_f40 = 0;
    this.tot_data.bal_f42 = 0;
    this.tot_data.bal_f44 = 0;
    this.tot_data.bal_f46 = 0;
    this.tot_data.bal_h36 = 0;
    this.tot_data.bal_h38 = 0;
    this.tot_data.bal_h40 = 0;
    this.tot_data.bal_h42 = 0;
    this.tot_data.bal_h44 = 0;
    this.tot_data.bal_h46 = 0;
    this.tot_data.bal_tot = 0;


    this.tot_data.est_f36 = 0;
    this.tot_data.est_f38 = 0;
    this.tot_data.est_f40 = 0;
    this.tot_data.est_f42 = 0;
    this.tot_data.est_f44 = 0;
    this.tot_data.est_f46 = 0;
    this.tot_data.est_h36 = 0;
    this.tot_data.est_h38 = 0;
    this.tot_data.est_h40 = 0;
    this.tot_data.est_h42 = 0;
    this.tot_data.est_h44 = 0;
    this.tot_data.est_h46 = 0;
    this.tot_data.est_tot = 0;


    this.tot_stock = 0;
    this.est_stock = 0;
    this.balance_qty = 0;
  }
  getNewDesignList() {
    this.salesOrderServ.getNewDesignList({}).then((res: any) => {
      this.newDesignList = res;
    });
  }
  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.fin_id = res.data[0].fin_id;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      // that.onSelectFinyear(res.data[0].fin_id);
      that.getSeasonList();
    });
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getBrandNewSeason(params).then((res: any) => {
      this.seasonList = res;
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, '0');
      let mm = String(today.getMonth() + 1).padStart(2, '0');
      let yyyy = today.getFullYear();

      let checkDate = yyyy + '-' + mm + '-' + dd;
      let curSeason = res.filter(el => checkDate >= el.order_from && checkDate <= el.order_to);
      this.allseason();
      if (curSeason.length > 0) {
        this.seasonCtrl.setValue(curSeason[0].season_id);
      } else {
        this.seasonCtrl.setValue(res[res["length"] - 1].season_id);
      }


    });
  }
  allseason() {
    let fin_id = parseInt(this.filter.fin_id);

    this.seasonList.forEach(() => {
      let seasonAll = {
        season: "ALL",
        season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
        fin_id: fin_id,
      };
      if (fin_id > 0) {
        this.seasonList.push(seasonAll);
      }
      fin_id = fin_id - 1;
    });
  }


  onGoToNextFld1($event, fld, ind) {
    if (fld == 'rf36')
      ind = ind + 1;
    setTimeout(() => {
      $("#" + fld + "-" + ind).focus()
    }, 100);
  }
  GetPartyview() {
    this.party_view = true;
  }
  SelectParty(id) {
    this.getNewPendingOrder(id);

  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  tabstyle(boolean) {
    this.tab_index = boolean;
  }
  allPartysave() {
    let that = this;
    swal({
      title: "Are you sure to save Party Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function (res: any) {
      //No Need For All Party Save Datas Individually Saved.
      // that.salesOrderServ
      // .SaveCounterdc(params)
      // .then(function (res: any) {
      that.toasterService.pop({
        bodyOutputType: 1,
        type: "success",
        title: "SUCCESS",
      });
    })
    // })
  }
  getNewPendingOrder(id: any) {
    this.IsWait = true;

    if (this.filter.newDesignShade == "") {
      this.filter.groupby = "design";
    }
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      filter: JSON.stringify(this.filter),
      party_id: id
    };

    let that = this;

    that.gridOptions = {
      loading: true,
      columns: [],
    };
    that.salesOrderServ.getcountersalesDC(params).then((res: any) => {
      that.IsWait = false;
      that.shirtStock = [];
      that.partyData = [];
      that.pendingOrderStock = [];
      that.Iselected_party = false;

      that.totpartyOrder = [];
      that.tot_data.so_f36 = 0;
      that.tot_data.so_f38 = 0;
      that.tot_data.so_f40 = 0;
      that.tot_data.so_f42 = 0;
      that.tot_data.so_f44 = 0;
      that.tot_data.so_f46 = 0;
      that.tot_data.so_h36 = 0;
      that.tot_data.so_h38 = 0;
      that.tot_data.so_h40 = 0;
      that.tot_data.so_h42 = 0;
      that.tot_data.so_h44 = 0;
      that.tot_data.so_h46 = 0;
      that.tot_data.so_tot = 0;


      that.tot_data.st_f36 = 0;
      that.tot_data.st_f38 = 0;
      that.tot_data.st_f40 = 0;
      that.tot_data.st_f42 = 0;
      that.tot_data.st_f44 = 0;
      that.tot_data.st_f46 = 0;
      that.tot_data.st_h36 = 0;
      that.tot_data.st_h38 = 0;
      that.tot_data.st_h40 = 0;
      that.tot_data.st_h42 = 0;
      that.tot_data.st_h44 = 0;
      that.tot_data.st_h46 = 0;
      that.tot_data.st_tot = 0;



      that.tot_data.bal_f36 = 0;
      that.tot_data.bal_f38 = 0;
      that.tot_data.bal_f40 = 0;
      that.tot_data.bal_f42 = 0;
      that.tot_data.bal_f44 = 0;
      that.tot_data.bal_f46 = 0;
      that.tot_data.bal_h36 = 0;
      that.tot_data.bal_h38 = 0;
      that.tot_data.bal_h40 = 0;
      that.tot_data.bal_h42 = 0;
      that.tot_data.bal_h44 = 0;
      that.tot_data.bal_h46 = 0;
      that.tot_data.bal_tot = 0;


      that.tot_data.est_f36 = 0;
      that.tot_data.est_f38 = 0;
      that.tot_data.est_f40 = 0;
      that.tot_data.est_f42 = 0;
      that.tot_data.est_f44 = 0;
      that.tot_data.est_f46 = 0;
      that.tot_data.est_h36 = 0;
      that.tot_data.est_h38 = 0;
      that.tot_data.est_h40 = 0;
      that.tot_data.est_h42 = 0;
      that.tot_data.est_h44 = 0;
      that.tot_data.est_h46 = 0;
      that.tot_data.est_tot = 0;


      that.tot_stock = 0;
      that.est_stock = 0;
      that.balance_qty = 0;



      that.pendingOrderStock = res.Pendordstock.data;

      that.totpartyOrder = res.Pendordstock.data
      that.shirtStock = res.stockpcs.data;
      that.partyData = res.party_data;

      that.filter.ref_no = res.ref_no;
      that.style_name = res.stockpcs.data[0].style;
      that.variety_name = res.stockpcs.data[0].type;
      that.setColumns(that.filter.groupby);

      if (that.pendingOrderStock.length > 0) {
        if (!that.pendingOrderStock[0].dc_id)
          that.party_view = false;
        that.pendingOrderStock.forEach(e => {
          that.tot_data.so_f36 += e.f36;
          that.tot_data.so_f38 += e.f38;
          that.tot_data.so_f40 += e.f40;
          that.tot_data.so_f42 += e.f42;
          that.tot_data.so_f44 += e.f44;
          that.tot_data.so_f46 += e.f46;
          that.tot_data.so_h36 += e.h36;
          that.tot_data.so_h38 += e.h38;
          that.tot_data.so_h40 += e.h40;
          that.tot_data.so_h42 += e.h42;
          that.tot_data.so_h44 += e.h44;
          that.tot_data.so_h46 += e.h46;

        });
        that.tot_data.so_tot = that.tot_data.so_f36 + that.tot_data.so_f38 + that.tot_data.so_f40 + that.tot_data.so_f42 + that.tot_data.so_f44 + that.tot_data.so_f46 + that.tot_data.so_h36 + that.tot_data.so_h38 + that.tot_data.so_h40 + that.tot_data.so_h42 + that.tot_data.so_h44 + that.tot_data.so_h46

      }
      if (res.stockpcs.data.length > 0) {
        that.shirtStock.forEach(e => {
          that.tot_data.est_tot = that.tot_stock += e.ware_tot
          that.tot_data.est_f36 = that.tot_data.st_f36 += e.f36;
          that.tot_data.est_f38 = that.tot_data.st_f38 += e.f38;
          that.tot_data.est_f40 = that.tot_data.st_f40 += e.f40;
          that.tot_data.est_f42 = that.tot_data.st_f42 += e.f42;
          that.tot_data.est_f44 = that.tot_data.st_f44 += e.f44;
          that.tot_data.est_f46 = that.tot_data.st_f46 += e.f46;
          that.tot_data.est_h36 = that.tot_data.st_h36 += e.h36;
          that.tot_data.est_h38 = that.tot_data.st_h38 += e.h38;
          that.tot_data.est_h40 = that.tot_data.st_h40 += e.h40;
          that.tot_data.est_h42 = that.tot_data.st_h42 += e.h42;
          that.tot_data.est_h44 = that.tot_data.st_h44 += e.h44;
          that.tot_data.est_h46 = that.tot_data.st_h46 += e.h46;

          e.bf36 = (e.f36 - 0);
          e.bf38 = (e.f38 - 0);
          e.bf40 = (e.f40 - 0);
          e.bf42 = (e.f42 - 0);
          e.bf44 = (e.f44 - 0);
          e.bf46 = (e.f46 - 0);
          e.bh36 = (e.h36 - 0);
          e.bh38 = (e.h38 - 0);
          e.bh40 = (e.h40 - 0);
          e.bh42 = (e.h42 - 0);
          e.bh44 = (e.h44 - 0);
          e.bh46 = (e.h46 - 0);




          if (e.attachment_name)
            that.attachment = e.attachment_name
        });

        that.tot_data.st_tot = that.tot_data.st_f36 + that.tot_data.st_f38 + that.tot_data.st_f40 + that.tot_data.st_f42 + that.tot_data.st_f44 + that.tot_data.st_f46 + that.tot_data.st_h36 + that.tot_data.st_h38 + that.tot_data.st_h40 + that.tot_data.st_h42 + that.tot_data.st_h44 + that.tot_data.st_h46
      }

      if (that.filter.groupby == "designColorOrder") {
        that.stockOrder = res.stockArr;
        that.totalOrderPend = res.totalOrderPend;
      }

      that.exceldata = that.getData(that.excelColumns, that.pendingOrderStock);

      // that.calcTotal(0, 0, '', 0,'');
    });
  }
  setColumns(groupby) {
    if (groupby == "design") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "Design No",
          prop: "design_no",
        },
        {
          name: "FTOT",
          prop: "ftot",
        },
        {
          name: "HTOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    } else if (groupby == "designColor") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "Design No",
          prop: "design_no",
        },
        {
          name: "Shade",
          prop: "shade",
        },
        {
          name: "F36",
          prop: "f36",
        },
        {
          name: "F38",
          prop: "f38",
        },
        {
          name: "F40",
          prop: "f40",
        },
        {
          name: "F42",
          prop: "f42",
        },
        {
          name: "F44",
          prop: "f44",
        },
        {
          name: "F46",
          prop: "f46",
        },
        {
          name: "H36",
          prop: "h36",
        },
        {
          name: "H38",
          prop: "h38",
        },
        {
          name: "H40",
          prop: "h40",
        },
        {
          name: "H42",
          prop: "h42",
        },
        {
          name: "H44",
          prop: "h44",
        },
        {
          name: "H46",
          prop: "h46",
        },
        {
          name: "F.TOT",
          prop: "ftot",
        },
        {
          name: "H.TOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    } else if (groupby == "designColorOrder") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "So.No",
          prop: "so_no",
        },
        {
          name: "So.Date",
          prop: "so_date",
        },
        {
          name: "Party Name",
          prop: "party_name",
        },
        {
          name: "F36",
          prop: "f36",
        },
        {
          name: "F38",
          prop: "f38",
        },
        {
          name: "F40",
          prop: "f40",
        },
        {
          name: "F42",
          prop: "f42",
        },
        {
          name: "F44",
          prop: "f44",
        },
        {
          name: "F46",
          prop: "f46",
        },
        {
          name: "H36",
          prop: "h36",
        },
        {
          name: "H38",
          prop: "h38",
        },
        {
          name: "H40",
          prop: "h40",
        },
        {
          name: "H42",
          prop: "h42",
        },
        {
          name: "H44",
          prop: "h44",
        },
        {
          name: "H46",
          prop: "h46",
        },
        {
          name: "F.TOT",
          prop: "ftot",
        },
        {
          name: "H.TOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    }
  }
  calcTotal(ind, val, str, id, size) {
    let tot_val = 0;
    this.pendingOrderStock.filter(el => el.design_id == id).forEach(e => {

      if (size == 'rf36') {
        tot_val += e.rf36 || 0
      }
      else if (size == 'rf38') {
        tot_val += e.rf38 || 0
      }
      else if (size == 'rf40') {
        tot_val += e.rf40 || 0
      }
      else if (size == 'rf42') {
        tot_val += e.rf42 || 0
      }
      else if (size == 'rf44') {
        tot_val += e.rf44 || 0
      }
      else if (size == 'rf46') {
        tot_val += e.rf46 || 0
      }
      else if (size == 'rh36') {
        tot_val += e.rh36 || 0
      }
      else if (size == 'rh38') {
        tot_val += e.rh38 || 0
      }
      else if (size == 'rh40') {
        tot_val += e.rh40 || 0
      }
      else if (size == 'rh42') {
        tot_val += e.rh42 || 0
      }
      else if (size == 'rh44') {
        tot_val += e.rh44 || 0
      }
      else if (size == 'rh46') {
        tot_val += e.rh46 || 0
      }
      e.rtot =  (e.rf36 || 0) + (e.rf38 || 0) + (e.rf40 || 0) + (e.rf42 || 0 ) + (e.rf44 || 0 ) + (e.rf46 || 0) + (e.rh36 || 0) + (e.rh38 || 0) + (e.rh40 || 0) + (e.rh42 || 0) + (e.rh44 || 0) +( e.rh46 || 0);
    });


   
    let temp: any;
    this.est_stock = 0;

    this.tot_data.est_f36 = 0;
    this.tot_data.est_f38 = 0;
    this.tot_data.est_f40 = 0;
    this.tot_data.est_f42 = 0;
    this.tot_data.est_f44 = 0;
    this.tot_data.est_f46 = 0;
    this.tot_data.est_h36 = 0;
    this.tot_data.est_h38 = 0;
    this.tot_data.est_h40 = 0;
    this.tot_data.est_h42 = 0;
    this.tot_data.est_h44 = 0;
    this.tot_data.est_h46 = 0;
    this.tot_data.est_tot = 0;


    this.tot_data.bal_f36 = 0;
    this.tot_data.bal_f38 = 0;
    this.tot_data.bal_f40 = 0;
    this.tot_data.bal_f42 = 0;
    this.tot_data.bal_f44 = 0;
    this.tot_data.bal_f46 = 0;
    this.tot_data.bal_h36 = 0;
    this.tot_data.bal_h38 = 0;
    this.tot_data.bal_h40 = 0;
    this.tot_data.bal_h42 = 0;
    this.tot_data.bal_h44 = 0;
    this.tot_data.bal_h46 = 0;
    this.tot_data.bal_tot = 0;


    this.shirtStock.forEach(e => {
      if (str == 'f36' && (e.design_id == id))
        e.bf36 = (e.f36 - tot_val);
      else if (str == 'f38' && (e.design_id == id))
        e.bf38 = (e.f38 - tot_val);
      else if (str == 'f40' && (e.design_id == id))
        e.bf40 = (e.f40 - tot_val);
      else if (str == 'f42' && (e.design_id == id))
        e.bf42 = (e.f42 - tot_val);
      else if (str == 'f44' && (e.design_id == id))
        e.bf44 = (e.f44 - tot_val);
      else if (str == 'f46' && (e.design_id == id))
        e.bf46 = (e.f46 - tot_val);

      else if (str == 'h36' && (e.design_id == id))
        e.bh36 = (e.h36 - tot_val);
      else if (str == 'h38' && (e.design_id == id))
        e.bh38 = (e.h38 - tot_val);
      else if (str == 'h40' && (e.design_id == id)) {
        e.bh40 = (e.h40 - tot_val);
      
      }
      else if (str == 'h42' && (e.design_id == id))
        e.bh42 = (e.h42 - tot_val);
      else if (str == 'h44' && (e.design_id == id))
        e.bh44 = (e.h44 - tot_val);
      else if (str == 'h46' && (e.design_id == id))
        e.bh46 = (e.h46 - tot_val);



      // e.rtot = (e.rf36 + e.rf38 + e.rf40 + e.rf42 + e.rf44 + e.rf46 + e.rh36 + e.rh38 + e.rh40 + e.rh42 + e.rh44 + e.rh46);

      this.tot_data.est_f36 += e.bf36;
      this.tot_data.est_f38 += e.bf38;
      this.tot_data.est_f40 += e.bf40;
      this.tot_data.est_f42 += e.bf42;
      this.tot_data.est_f44 += e.bf44;
      this.tot_data.est_f46 += e.bf46;
      this.tot_data.est_h36 += e.bh36;
      this.tot_data.est_h38 += e.bh38;
      this.tot_data.est_h40 += e.bh40;
      this.tot_data.est_h42 += e.bh42;
      this.tot_data.est_h44 += e.bh44;
      this.tot_data.est_h46 += e.bh46;

      // this.tot_data.bal_f36 += e.bf36;
      // this.tot_data.bal_f38 += e.bf38;
      // this.tot_data.bal_f40 += e.bf40;
      // this.tot_data.bal_f42 += e.bf42;
      // this.tot_data.bal_f44 += e.bf44;
      // this.tot_data.bal_f46 += e.bf46;
      // this.tot_data.bal_h36 += e.bh36;
      // this.tot_data.bal_h38 += e.bh38;
      // this.tot_data.bal_h40 += e.bh40;
      // this.tot_data.bal_h42 += e.bh42;
      // this.tot_data.bal_h44 += e.bh44;
      // this.tot_data.bal_h46 += e.bh46;


      // this.est_stock += e.rtot;

    })

  
    this.tot_data.bal_tot = this.tot_data.bal_f36 + this.tot_data.bal_f38 + this.tot_data.bal_f40 + this.tot_data.bal_f42 + this.tot_data.bal_f44 + this.tot_data.bal_f46 + this.tot_data.bal_h36 + this.tot_data.bal_h38 + this.tot_data.bal_h40 + this.tot_data.bal_h42 + this.tot_data.bal_h44 + this.tot_data.bal_h46


    this.tot_data.est_tot = this.tot_data.est_f36 + this.tot_data.est_f38 + this.tot_data.est_f40 + this.tot_data.est_f42 + this.tot_data.est_f44 + this.tot_data.est_f46 + this.tot_data.est_h36 + this.tot_data.est_h38 + this.tot_data.est_h40 + this.tot_data.est_h42 + this.tot_data.est_h44 + this.tot_data.est_h46

    this.balance_qty = this.tot_stock - this.est_stock;

    // for (let i = 0; i < this.shirtStock.length; i++) {
    //   //ftotalpcs
    //   this.shirtStock[ind]["rtot"] =
    //     Number(this.shirtStock[ind]["rf36"]) +
    //     Number(this.shirtStock[ind]["rf38"]) +
    //     Number(this.shirtStock[ind]["rf40"]) +
    //     Number(this.shirtStock[ind]["rf42"]) +
    //     Number(this.shirtStock[ind]["rf44"]) +
    //     Number(this.shirtStock[ind]["rf46"]) +
    //     Number(this.shirtStock[ind]["rh36"]) +
    //     Number(this.shirtStock[ind]["rh38"]) +
    //     Number(this.shirtStock[ind]["rh40"]) +
    //     Number(this.shirtStock[ind]["rh42"]) +
    //     Number(this.shirtStock[ind]["rh44"]) +
    //     Number(this.shirtStock[ind]["rh46"]);

    // }
    // let tot_f36 = 0;
    // let tot_f38 = 0;
    // let tot_f40 = 0;
    // let tot_f42 = 0;
    // let tot_f44 = 0;
    // let tot_f46 = 0;
    // let tot_h36 = 0;
    // let tot_h38 = 0;
    // let tot_h40 = 0;
    // let tot_h42 = 0;
    // let tot_h44 = 0;
    // let tot_h46 = 0;

    // this.tot_data.est_f36 = 0;
    // this.tot_data.est_f38 = 0;
    // this.tot_data.est_f40 = 0;
    // this.tot_data.est_f42 = 0;
    // this.tot_data.est_f44 = 0;
    // this.tot_data.est_f46 = 0;
    // this.tot_data.est_h36 = 0;
    // this.tot_data.est_h38 = 0;
    // this.tot_data.est_h40 = 0;
    // this.tot_data.est_h42 = 0;
    // this.tot_data.est_h44 = 0;
    // this.tot_data.est_h46 = 0;

    // this.shirtStock.forEach((ele, i) => {
    //   this.est_stock += ele.rtot;

    //   temp = this.shirtStock[ind]
    //   if (ele.code == temp.code) {
    //     tot_f36 += ele.rf36;
    //     tot_f38 += ele.rf38;
    //     tot_f40 += ele.rf40;
    //     tot_f42 += ele.rf42;
    //     tot_f44 += ele.rf44;
    //     tot_f46 += ele.rf46;
    //     tot_h36 += ele.rh36;
    //     tot_h38 += ele.rh38;
    //     tot_h40 += ele.rh40;
    //     tot_h42 += ele.rh42;
    //     tot_h44 += ele.rh44;
    //     tot_h46 += ele.rh46;
    //   }

    //   this.tot_data.est_f36 += ele.rf36;
    //   this.tot_data.est_f38 += ele.rf38;
    //   this.tot_data.est_f40 += ele.rf40;
    //   this.tot_data.est_f42 += ele.rf42;
    //   this.tot_data.est_f44 += ele.rf44;
    //   this.tot_data.est_f46 += ele.rf46;
    //   this.tot_data.est_h36 += ele.rh36;
    //   this.tot_data.est_h38 += ele.rh38;
    //   this.tot_data.est_h40 += ele.rh40;
    //   this.tot_data.est_h42 += ele.rh42;
    //   this.tot_data.est_h44 += ele.rh44;
    //   this.tot_data.est_h46 += ele.rh46;


    // });

    // this.tot_data.bal_f36 = 0;
    // this.tot_data.bal_f38 = 0;
    // this.tot_data.bal_f40 = 0;
    // this.tot_data.bal_f42 = 0;
    // this.tot_data.bal_f44 = 0;
    // this.tot_data.bal_f46 = 0;
    // this.tot_data.bal_h36 = 0;
    // this.tot_data.bal_h38 = 0;
    // this.tot_data.bal_h40 = 0;
    // this.tot_data.bal_h42 = 0;
    // this.tot_data.bal_h44 = 0;
    // this.tot_data.bal_h46 = 0;



    // this.shirtStock.forEach(e => {
    //   if (e.code == temp.code) {
    //     e.bf36 = (e.f36 - tot_f36);
    //     e.bf38 = (e.f38 - tot_f38);
    //     e.bf40 = (e.f40 - tot_f40);
    //     e.bf42 = (e.f42 - tot_f42);
    //     e.bf44 = (e.f44 - tot_f44);
    //     e.bf46 = (e.f46 - tot_f46);
    //     e.bh36 = (e.h36 - tot_h36);
    //     e.bh38 = (e.h38 - tot_h38);
    //     e.bh40 = (e.h40 - tot_h40);
    //     e.bh42 = (e.h42 - tot_h42);
    //     e.bh44 = (e.h44 - tot_h44);
    //     e.bh46 = (e.h46 - tot_h46);
    //   }

    //   this.tot_data.bal_f36 += e.bf36;
    //   this.tot_data.bal_f38 += e.bf38;
    //   this.tot_data.bal_f40 += e.bf40;
    //   this.tot_data.bal_f42 += e.bf42;
    //   this.tot_data.bal_f44 += e.bf44;
    //   this.tot_data.bal_f46 += e.bf46;
    //   this.tot_data.bal_h36 += e.bh36;
    //   this.tot_data.bal_h38 += e.bh38;
    //   this.tot_data.bal_h40 += e.bh40;
    //   this.tot_data.bal_h42 += e.bh42;
    //   this.tot_data.bal_h44 += e.bh44;
    //   this.tot_data.bal_h46 += e.bh46;
    // })

  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  onSelectClicked(event, i) {
    this.Iselected_party = false;

    if (event.target.checked) {
      this.filter.est_partyid = this.pendingOrderStock[i].party_id;
      this.pendingOrderStock = this.pendingOrderStock.filter(
        e => e.party_id == this.filter.est_partyid

      )
      this.Iselected_party = true;
      this.tot_data.so_f36 = 0;
      this.tot_data.so_f38 = 0;
      this.tot_data.so_f40 = 0;
      this.tot_data.so_f42 = 0;
      this.tot_data.so_f44 = 0;
      this.tot_data.so_f46 = 0;
      this.tot_data.so_h36 = 0;
      this.tot_data.so_h38 = 0;
      this.tot_data.so_h40 = 0;
      this.tot_data.so_h42 = 0;
      this.tot_data.so_h44 = 0;
      this.tot_data.so_h46 = 0;
      this.tot_data.so_tot = 0;

      this.pendingOrderStock.forEach(e => {
        this.tot_data.so_f36 += e.f36;
        this.tot_data.so_f38 += e.f38;
        this.tot_data.so_f40 += e.f40;
        this.tot_data.so_f42 += e.f42;
        this.tot_data.so_f44 += e.f44;
        this.tot_data.so_f46 += e.f46;
        this.tot_data.so_h36 += e.h36;
        this.tot_data.so_h38 += e.h38;
        this.tot_data.so_h40 += e.h40;
        this.tot_data.so_h42 += e.h42;
        this.tot_data.so_h44 += e.h44;
        this.tot_data.so_h46 += e.h46;
      });

      this.tot_data.so_tot = this.tot_data.so_f36 + this.tot_data.so_f38 + this.tot_data.so_f40 + this.tot_data.so_f42 + this.tot_data.so_f44 + this.tot_data.so_f46 + this.tot_data.so_h36 + this.tot_data.so_h38 + this.tot_data.so_h40 + this.tot_data.so_h42 + this.tot_data.so_h44 + this.tot_data.so_h46

    }
    //    this.pendingOrderStock[i].isChecked = true;
    // else
    //    this.pendingOrderStock[i].isChecked = false;
    //  let res = this.pendingOrderStock.filter(
    //    (e) => e.isChecked == true
    //  )

  }
  onDesignClick(stock) {
    if (this.filter.groupby == "design") {
      this.filter.groupby = "designColor";
      this.filter.newDesignShade = stock.design_no;
    } else if (this.filter.groupby == "designColor") {
      this.filter.groupby = "designColorOrder";
      this.filter.newDesignShade = stock.design_no;
      this.filter.shade = stock.shade;
    }

  }

  ngOnDestroy() {
    this.salesOrderServ;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/designSoReport/counterdcReport.ts